export const RETURN_STATUS = {
  submitted: { label: "تم تقديم الطلب", color: "#3B82F6" },
  under_review: { label: "قيد المراجعة", color: "#F59E0B" },
  awaiting_yard: { label: "بانتظار رد التشليح", color: "#F59E0B" },
  awaiting_customer_info: { label: "بانتظار معلومات منك", color: "#F59E0B" },
  approved: { label: "تمت الموافقة", color: "#10B981" },
  rejected: { label: "مرفوض", color: "#EF4444" },
  awaiting_pickup: { label: "بانتظار استلام القطعة", color: "#F59E0B" },
  item_received: { label: "تم استلام القطعة", color: "#10B981" },
  exchanging: { label: "جاري الاستبدال", color: "#F59E0B" },
  exchanged: { label: "تم الاستبدال", color: "#10B981" },
  refunding: { label: "جاري استرداد المبلغ", color: "#F59E0B" },
  refunded: { label: "تم استرداد المبلغ", color: "#10B981" },
  closed: { label: "مغلق", color: "#94A3B8" },
};

export const RETURN_REASONS = [
  ["different", "القطعة مختلفة عن المطلوبة"],
  ["not_as_described", "القطعة لا تطابق الوصف"],
  ["damaged", "القطعة تالفة"],
  ["defective", "يوجد عيب في القطعة"],
  ["specs_mismatch", "المواصفات غير مطابقة"],
  ["not_suitable", "القطعة غير مناسبة للمواصفات المتفق عليها"],
  ["other", "سبب آخر"],
];

export const ReturnBadge = ({ status }) => {
  const s = RETURN_STATUS[status] || { label: status, color: "#94A3B8" };
  return (
    <span className="inline-flex items-center gap-1.5 rounded-lg px-2.5 py-1 text-xs font-bold"
      style={{ backgroundColor: `${s.color}22`, color: s.color }}>
      <span className="h-1.5 w-1.5 rounded-full" style={{ backgroundColor: s.color }} />
      {s.label}
    </span>
  );
};
